[
  {"id": "cha", "shown": "cha", "aliases": []},
  {"id": "cham", "shown": "cham", "aliases": []},
  {"id": "di", "shown": "di", "aliases": ["dhi"]},
  {"id": "din", "shown": "din", "aliases": ["dhin"]},
  {"id": "dim", "shown": "dim", "aliases": ["dhim", "dheem"]},
  {"id": "dit", "shown": "dit", "aliases": ["dhit"]},
  {"id": "dhom", "shown": "dhom", "aliases": ["dom"]},
  {"id": "thom", "shown": "thom", "aliases": []},
  {"id": "du", "shown": "du", "aliases": ["dhu"]},
  {"id": "ga", "shown": "ga", "aliases": []},
  {"id": "gin", "shown": "gin", "aliases": []},
  {"id": "gu", "shown": "gu", "aliases": []},
  {"id": "jo", "shown": "jo", "aliases": ["ja"]},
  {"id": "ka", "shown": "ka", "aliases": []},
  {"id": "ki", "shown": "ki", "aliases": []},
  {"id": "ku", "shown": "ku", "aliases": []},
  {"id": "kum", "shown": "kum", "aliases": []},
  {"id": "lang", "shown": "lang", "aliases": []},
  {"id": "mi", "shown": "mi", "aliases": []},
  {"id": "na", "shown": "na", "aliases": []},
  {"id": "nam", "shown": "nam", "aliases": []},
  {"id": "nang", "shown": "nang", "aliases": []},
  {"id": "nu", "shown": "nu", "aliases": []},
  {"id": "ri", "shown": "ri", "aliases": []},
  {"id": "ta", "shown": "ta", "aliases": ["ṭa"]},
  {"id": "tha", "shown": "tha", "aliases": []},
  {"id": "tat", "shown": "tat", "aliases": []},
  {"id": "tam", "shown": "tam", "aliases": []},
  {"id": "tang", "shown": "tang", "aliases": []},
  {"id": "ti", "shown": "ti", "aliases": []},
  {"id": "tong", "shown": "tong", "aliases": []}
]
